module.exports = __webpack_public_path__ + "static/img/banner.dd31e01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/banner.png
// module id = t81L
// module chunks = 0